import { render } from "./backgroundPresenter.vue?vue&type=template&id=1027b86f&scoped=true"
import script from "./backgroundPresenter.vue?vue&type=script&lang=js"
export * from "./backgroundPresenter.vue?vue&type=script&lang=js"

import "./backgroundPresenter.vue?vue&type=style&index=0&id=1027b86f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\siemens-ecdp-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1027b86f"]])

export default __exports__